import { render, staticRenderFns } from "./CompanyShow.vue?vue&type=template&id=48037e9d&scoped=true&"
import script from "./CompanyShow.vue?vue&type=script&lang=js&"
export * from "./CompanyShow.vue?vue&type=script&lang=js&"
import style0 from "./CompanyShow.vue?vue&type=style&index=0&id=48037e9d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48037e9d",
  null
  
)

export default component.exports